export default (function (itemsArray, index) {
  return itemsArray.length - 1 === index;
});